import { LogOutIcon, UserRoundIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSnapshot } from 'valtio';

import { authState } from '../../../services/state/auth-state.jsx';
import { getInitials } from '../../../utils/misc.js';

import { Avatar, AvatarFallback } from '../../ui/avatar.jsx';
import { Button } from '../../ui/button.jsx';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../../ui/dropdown-menu.jsx';

export function ProfileDropdown() {
  const { user: loggedUser, logout } = useSnapshot(authState);

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative size-9 rounded-xl">
          <Avatar className="size-9 rounded-xl border border-input">
            <AvatarFallback className="size-9 rounded-xl dark:bg-muted/40">
              {getInitials(loggedUser.fullName)}
            </AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end" forceMount>
        <DropdownMenuLabel className="font-normal">
          <div className="flex items-center gap-2.5 px-1 py-1.5 text-left text-sm">
            <Avatar className="size-8 rounded-xl border border-input">
              <AvatarFallback className="rounded-xl dark:bg-muted/40">
                {getInitials(loggedUser.fullName)}
              </AvatarFallback>
            </Avatar>
            <div className="grid flex-1 text-left text-sm leading-tight">
              <span className="truncate font-semibold">
                {loggedUser.fullName}
              </span>
              <span className="truncate text-xs">
                {loggedUser.details.role}
              </span>
              <span className="truncate text-xs">{loggedUser.email}</span>
            </div>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem asChild>
            <Link to="/backoffice/account">
              <UserRoundIcon className="mr-2 size-3.5" />
              Conta
            </Link>
          </DropdownMenuItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => logout()}>
          <LogOutIcon className="mr-2 size-3.5" />
          Sair
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
